var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M12.219 5.563v3.375Q8 11.563 3.78 8.938V5.563m-1.687-.625v5.75m0 0c.625 0 1.125.5 1.125 1.125v2.375H.969v-2.375c0-.625.5-1.125 1.125-1.125m5.875-3.563l-7-2.625 7-2.687L15.03 4.5z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMTIuMjE5IDUuNTYzdjMuMzc1UTggMTEuNTYzIDMuNzggOC45MzhWNS41NjNtLTEuNjg3LS42MjV2NS43NW0wIDBjLjYyNSAwIDEuMTI1LjUgMS4xMjUgMS4xMjV2Mi4zNzVILjk2OXYtMi4zNzVjMC0uNjI1LjUtMS4xMjUgMS4xMjUtMS4xMjVtNS44NzUtMy41NjMtNy0yLjYyNSA3LTIuNjg3TDE1LjAzIDQuNXoiLz48L3N2Zz4=";
export { SvgIconEducation as ReactComponent };